import React from 'react';
import Box from '@mui/material/Box';
import {IGameDetailCharacterProps} from '@wearesection/bandai-react-components/organisms/GameDetailCharacter';
import {ComponentPropsAdapter} from '../../types';
import {Characters, Maybe, NewsContent} from '~/graphql/types';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
import {getOptions} from '../body-article/body-rich-text-renderer-options';
import {PLACEHOLDER_IMG} from '~/constants';
import {GetRouter} from '~/utils';
import {usePageSetting} from '~/providers/page-context.provider';
import dynamic from 'next/dynamic';
const GameDetailCharacter = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/GameDetailCharacter')
);

type IGameDetailCharacterPropsExt = IGameDetailCharacterProps & {
  characterDetailList: Characters[];
};
const adapter: ComponentPropsAdapter<
  IGameDetailCharacterPropsExt,
  IGameDetailCharacterProps
> = data => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? [];

  return {
    title: data?.title ?? '',
    characterDetailList:
      data?.characterDetailList?.map((character: Characters) => {
        return {
          thumbnailImg: character?.characterImage?.media?.url ?? PLACEHOLDER_IMG,
          thumbnailAlt: character?.characterImage?.alt ?? '',
          name: character?.title ?? '',
          power: '',
          serviceRecord:
            documentToReactComponents(
              character?.description?.json,
              getOptions(character?.description as Maybe<NewsContent>)
            ) ?? '',
          quote: '',
          history:
            documentToReactComponents(
              character?.additionalDescription?.json,
              getOptions(character?.additionalDescription as Maybe<NewsContent>)
            ) ?? '',
        };
      }) || [],
  };
};

const PADDING_COMPONENT: any = {
  '/games/[slug]': {
    overflow: 'hidden',
    paddingTop: {
      xs: '72px',
      lg: '40px',
    },
    paddingBottom: {
      xs: '72px',
      lg: '40px',
    },
  },
};

const GameDetailCharacterOrganisms: React.FC<IGameDetailCharacterPropsExt> = props => {
  const ComponentProps = adapter(props);
  const {pathname} = GetRouter();
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? {}}>
      <GameDetailCharacter {...ComponentProps} id={props?.id || ''} />
    </Box>
  );
};

export default GameDetailCharacterOrganisms;
